// extracted by mini-css-extract-plugin
module.exports = {"divider":"Home_divider__YUUKf"};